'use strict';

const foot = {
  template: `
    <footer class="hide-for-print">

      <div class="row">
        <div class="large-12 columns">
          <hr/>
        </div>
      </div>

      <div class="row">
        <div class="large-4 columns">
          Gratis brukerst&oslash;tte p&aring; e-post: <b><a href="mailto:hjelp@sendregning.no">hjelp@sendregning.no</a></b>
          <br/> Svar innen en virkedag.
          <p>
            <a href="/sluttbrukeravtale/" target="_blank">Sluttbrukeravtale</a>
          </p>
        </div>

<!--        <div class="large-4 columns">-->
<!--          <ul class="inline-list right social">-->
<!--            <li>-->
<!--              <a class="fa fa-rss-square" href="https://www.sendregning.no/feed.xml" target="_blank"></a>-->
<!--            </li>-->
<!--            <li>-->
<!--              <a class="fa fa-facebook-square" href="http://facebook.com/sendregning" target="_blank"></a>-->
<!--            </li>-->
<!--            <li>-->
<!--              <a class="fa fa-twitter-square" href="https://twitter.com/sendregning" target="_blank"></a>-->
<!--            </li>-->
<!--            <li>-->
<!--              <a class="fa fa-google-plus-square" href="https://plus.google.com/+sendregning" target="_blank"></a>-->
<!--            </li>-->
<!--            <li>-->
<!--              <a class="fa fa-youtube-square" href="http://youtube.no/sendregning" target="_blank"></a>-->
<!--            </li>-->
<!--            <li>-->
<!--              <a class="fa fa-instagram" href="https://www.instagram.com/sendregning/" target="_blank"></a>-->
<!--            </li>-->
<!--          </ul>-->
<!--        </div>-->

      </div>

    </footer>
  `
};

angular
  .module('SendRegning')
  .component('foot', foot);
